exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager #not-found .not-found-img{opacity:.5}#doc-manager #not-found .not-found-label{margin-top:30px;margin-bottom:0;font-style:normal;font-weight:700;font-size:24px;line-height:54px;color:#38404f}#doc-manager #not-found .not-found-message{margin-top:16px;margin-bottom:0;width:320px;font-style:normal;font-weight:600;font-size:14px;line-height:21px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;color:#38404f}#doc-manager #not-found .retry-button{margin-top:30px}", ""]);

// exports
